import { extractLastNameComponent } from '@spotify/confidence-core-react';
import {
  ActivityChangeOptions,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { createFlagUpdatesChangeExtension } from '@spotify/plugin-confidence-flags-react';
import { useIdentity } from '@spotify/plugin-confidence-iam-react';

const useDisplayName = (identityName: string | null | undefined): string => {
  const { identity } = useIdentity({
    name: identityName ?? '',
    skip: !identityName,
  });
  return (
    identity?.displayName ??
    extractLastNameComponent(identityName ?? '') ??
    'Unknown'
  );
};

const OwnerUpdates = ({ change }: ActivityChangeOptions) => {
  const oldName = useDisplayName(change.oldValue);
  const newName = useDisplayName(change.newValue);

  return <ActivityTagItem oldValue={oldName} newValue={newName} />;
};

export const SEGMENT_OWNER_CHANGE_EXTENSION = createFlagUpdatesChangeExtension({
  id: 'segment-owner-change',
  priority: 1,
  predicate: ({ change }) => change.fieldPath === '/owner',
  title: () => 'Transferred ownership',
  render: OwnerUpdates,
});
